import React, { useEffect } from "react";

const Reviews = ({ reviews }) => {
    useEffect(() => {
        const swiperCss = document.createElement("link");
        swiperCss.rel = "stylesheet";
        swiperCss.href = "https://unpkg.com/swiper/swiper-bundle.min.css";
        document.head.appendChild(swiperCss);

        const swiperScript = document.createElement("script");
        swiperScript.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
        swiperScript.async = true;

        swiperScript.onload = () => {
            if (window.Swiper) {
                new window.Swiper(".swiper", {
                    loop: true,
                    autoplay: { delay: 10000 },
                    navigation: { nextEl: ".x-swiper-button-next", prevEl: ".x-swiper-button-prev" },
                    breakpoints: {
                        // Mobile
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 16,
                        },
                        // Tablet
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        // Desktop
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });
            }
        };

        document.body.appendChild(swiperScript);

        return () => {
            document.head.removeChild(swiperCss);
            document.body.removeChild(swiperScript);
        };
    }, []);

    return (
        <div className="bg-[#F5F1ED] pt-[40px] pb-[40px] md:pb-[138px] w-full">
            <div className="max-w-[1440px] px-[20px] md:px-[80px] mx-auto w-full">
                <div className="mb-[40px] flex justify-between md:hidden items-end gap-[17px]">
                    <h2 className="max-w-[265px] text-[20px] font-normal text-[#1D1D1D]">
                        Hear What Our Customers Are Saying About Us
                    </h2>
                    <div className="flex gap-3">
                        <button className="x-swiper-button-next relative top-0 left-0 border-0 bg-none">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#1D1D1D" />
                            </svg>
                        </button>
                        <button className="x-swiper-button-prev relative top-0 left-0 border-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#1D1D1D" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="swiper">
                    <div className="swiper-wrapper">
                        {reviews.map((review, index) => (
                            <div
                                key={index}
                                className="swiper-slide bg-white py-[32px] px-[32px] rounded-[15px] shadow-sm flex flex-col gap-y-4"
                            >
                                <div className="flex gap-x-[4px]">
                                    {Array(5)
                                        .fill(0)
                                        .map((_, i) => (
                                                <svg key={i} xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                                                    <path className={`text-[30px] ${i < review.rating ? "fill-[#699357]" : "fill-gray-300"}`}  d="M9.07088 0.612343C9.41462 -0.204115 10.5854 -0.204114 10.9291 0.612346L12.9579 5.43123C13.1029 5.77543 13.4306 6.01061 13.8067 6.0404L19.0727 6.45748C19.9649 6.52814 20.3267 7.62813 19.6469 8.2034L15.6348 11.5987C15.3482 11.8412 15.223 12.2218 15.3106 12.5843L16.5363 17.661C16.744 18.5211 15.7969 19.201 15.033 18.7401L10.5245 16.0196C10.2025 15.8252 9.7975 15.8252 9.47548 16.0196L4.96699 18.7401C4.20311 19.201 3.25596 18.5211 3.46363 17.661L4.68942 12.5843C4.77698 12.2218 4.65182 11.8412 4.36526 11.5987L0.353062 8.2034C-0.326718 7.62813 0.0350679 6.52814 0.927291 6.45748L6.19336 6.0404C6.5695 6.01061 6.89716 5.77543 7.04207 5.43123L9.07088 0.612343Z" />
                                                </svg>
                                        ))}
                                </div>
                                <p className="text-[#1D1D1D] font-normal text-[16px] mt-[32px] h-[96px] md:h-[72px] overflow-auto">
                                    "{review.comment}"
                                </p>
                                <div className="flex items-center gap-x-[16px] mt-[32px]">
                                    <img
                                        src={review.image}
                                        alt={review.author}
                                        className="w-[56px] h-[56px] rounded-full object-cover"
                                    />
                                    <div>
                                        <h4 className="text-[#1D1D1D] text-base font-medium leading-6">
                                            {review.author}
                                        </h4>
                                        <p className="text-[#1D1D1D] text-base font-normal leading-6">
                                            {review.position}, {review.company}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reviews;
